import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { NgxEchartsModule } from 'ngx-echarts';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { provideKeycloak } from 'keycloak-angular';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
    provideAnimationsAsync(),
    importProvidersFrom(NgxEchartsModule, NgxChartsModule), provideAnimationsAsync(),
    provideKeycloak({
      config: {
        url: 'https://auth.alpha.simadvisory.com/',
        realm: 'SIM_TOOLS',
        clientId: 'U_dexcat_client'
      },
      initOptions: {
        onLoad: "login-required", // redirects to the login page
        checkLoginIframe: false,
        checkLoginIframeInterval: 1000,
      }
    }),
  ],
};
